// extracted by mini-css-extract-plugin
export default {"centeredText":"Ag0WbWIpHeG9KJq4p2sZ"};